/* eslint-disable camelcase */
import React from 'react';
import { Box, Chip, Grid, Stack, Typography } from '@mui/material';
import getPriceLabel from 'utilities/priceDisplay';
import formatCurrency from 'utilities/formatCurrency';
// eslint-disable-next-line camelcase
import { Luci_Shopping_Api_Models_OrderItem, Luci_Shopping_Api_Models_ImageWithVariants } from 'types/api/v7.1';
import ImageCover from '../ImageCover';
import Styles from './ProductLineItem.module.scss';

const ProductLineItem = ({
  id,
  image,
  type,
  description,
  name,
  sku,
  quantity,
  salePrice,
  isFree,
  isReward,
  tags,
}: Luci_Shopping_Api_Models_OrderItem): JSX.Element => {
  const isFreeItem: boolean = isFree || sku === 'PFAC';
  return (
    <>
      <Grid
        container
        spacing={2}
        className={Styles.item}
        data-testid={`${type}-${id}-${sku}`}
      >
        <Grid item padding={0} margin={0} xs={6}>
          <Box>
            <ImageCover
              data-testid="product-image"
              src={
                (image as Luci_Shopping_Api_Models_ImageWithVariants)?.originalImage?.url ||
                'https://shop.paparazzipremiere.com/static/media/inventory_image_1024x1024.fdc7147ba9120b8ad3af.png'
              }
              alt={description || ''}
              objectFit="scale-down"
            />
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Stack
            component="aside"
            role="group"
            aria-label={`Product Details for ${name}`}
            gap={1}
            alignItems="start"
            data-testid={'order-details'}
          >
            <Typography component="h4" variant="body1">
              <strong>{name}</strong>
            </Typography>
            {sku && (
              <Typography
                component="h5"
                variant="body2"
                sx={{ wordBreak: 'break-all' }}
              >
                SKU: {sku}
              </Typography>
            )}
            { (!Number.isNaN(id) && id && id > 0) && (
              <Typography component="h5" variant="body2">
                Item #{id}
              </Typography>
            )}
            <Typography component="h5" variant="body2">
              Quantity: {quantity}
            </Typography>
            <div data-testid={'order-pricing-information'}>
              <Typography component="h5" variant="body2">
                {(isFreeItem || isReward) && (
                  <strong role="status">
                    {getPriceLabel(!!isFreeItem, !!isReward)}
                  </strong>
                )}
              </Typography>
              {salePrice && sku && sku !== 'PFAC' && !isFree && !isReward && (
                <Typography align="right" component="h5" variant="body1">
                  <data value={formatCurrency(salePrice)}>
                    {formatCurrency(salePrice)}
                  </data>
                </Typography>
              )}
            </div>
            {tags ? (
              <Stack spacing={2} data-testid={'product-variants'}>
                {tags.length > 0 && (
                  <Box>
                    {tags.map((tag) => (
                      <Stack
                        direction="row"
                        spacing={1}
                        key={`${tag?.id}-${tag.sortOrder}-${tag}-${name}`}
                      >
                        <Typography variant="subtitle1">{tag.name}</Typography>
                        <Chip
                          sx={{ borderRadius: '.25rem' }}
                          label={tag?.name}
                          variant={tag?.name ? 'filled' : 'outlined'}
                        />
                      </Stack>
                    ))}
                  </Box>
                )}
              </Stack>
            ) : null}
          </Stack>
        </Grid>
      </Grid>
    </>
  );
};

export default ProductLineItem;
